import { generateFundingLinkForDuplicates } from "../../../../util/constants/generateFundingLinkForDuplicates";
export const baseColumnsForDuplicates = [
  {
    id: "fundRequestId",
    header: "Potential Duplicate Fund Request Id",
    cell: (e) => generateFundingLinkForDuplicates(e.fundRequestId),
  },
  {
    id: "opportunityId",
    header: "Ace Opportunity Id",
    cell: (e) => e.opportunityId,
  },
  {
    id: "programEngagementId",
    header: "Program Engagement Id",
    cell: (e) => (e.programEngagementId ? e.programEngagementId : "-"),
  },
  {
    id: "migrationPhase",
    header: "Migration Phase",
    cell: (e) => (e.migrationPhase ? e.migrationPhase : "-"),
  },
  {
    id: "activityName",
    header: "Activity Name",
    cell: (e) => (e.activityName ? e.activityName : "-"),
  },
  {
    id: "partnerName",
    header: "Partner Name",
    cell: (e) => (e.partnerName ? e.partnerName : "-"),
  },
  {
    id: "approvedAmount",
    header: "Approved Amount",
    cell: (e) => (e.approvedAmount ? e.approvedAmount : "-"),
  },
  {
    id: "stage",
    header: "Stage",
    cell: (e) => e.stage,
  },
  {
    id: "awsOpportunityId",
    header: "AWS Opportunity Id",
    cell: (e) => (e.awsOpportunityId ? e.awsOpportunityId : "-"),
  },
];

export const duplicateReasonColumn = [
  {
    id: "duplicateReason",
    header: "Duplicate Reason",
    cell: (e) =>
      e.duplicateReason ? getDuplicateReasonAsText(e.duplicateReason) : "-",
  },
];
export const fundRequestDuplicatesColumnDefinitions = [
  ...baseColumnsForDuplicates,
  ...duplicateReasonColumn,
];

export const fundRequestNonDeterministicDuplicatesColumnDefinitions = [
  ...baseColumnsForDuplicates,
  {
    id: "businessDescription",
    header: "Business Description",
    cell: (e) =>
      e.businessDescription ? e.businessDescription.slice(0, 100) + "..." : "-",
  },
  {
    id: "customerCompanyName",
    header: "Ace Opportunity Customer Company Name",
    cell: (e) => (e.customerCompanyName ? e.customerCompanyName : "-"),
  },
  {
    id: "awsAccountName",
    header: "AWS Account Name",
    cell: (e) => (e.awsAccountName ? e.awsAccountName : "-"),
  },
  {
    id: "aceOpportunityCustomerBusinessProblem",
    header: "Ace Opportunity Customer Business Problem",
    cell: (e) =>
      e.aceOpportunityCustomerBusinessProblem
        ? e.aceOpportunityCustomerBusinessProblem.slice(0, 100) + "..."
        : "-",
  },
  {
    id: "aceOpportunityPartnerProjectTitle",
    header: "Ace Opportunity Partner Project Title",
    cell: (e) =>
      e.aceOpportunityPartnerProjectTitle
        ? e.aceOpportunityPartnerProjectTitle
        : "-",
  },
  ...duplicateReasonColumn,
];

export const searchableColumns = [
  "fundRequestId",
  "opportunityId",
  "programEngagementId",
  "migrationPhase",
  "activityName",
  "partnerName",
  "approvedAmount",
  "stage",
];

const getDuplicateReasonAsText = (reasons) => {
  if (reasons.length === 0) {
    return "-";
  }

  return reasons.join(", ");
};
